import { render } from "./BasketProducts.vue?vue&type=template&id=70563b0d&scoped=true"
import script from "./BasketProducts.vue?vue&type=script&lang=js"
export * from "./BasketProducts.vue?vue&type=script&lang=js"

import "./BasketProducts.vue?vue&type=style&index=0&id=70563b0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70563b0d"]])

export default __exports__